import {WeaLocaleProvider} from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

const labelcol = 4;
const fieldcol = 16;
export const fields = [{
    domkey: ['template'],
    conditionType: 'input',
    label: getLabel(28576,"下载模板"),
    viewAttr: 1,
    rules: 'string',
}, {
    domkey: ['uploadExe'],
    conditionType: 'button',
    label:getLabel(16630,"上传Excel"),
    viewAttr: 3,
    rules: 'required|string',
}, {
    conditionType: "SELECT",
    domkey: ['checkCode'],
    viewAttr: 2,
    label: getLabel(24638,"重复验证字段"),
    options: [],
}, {
    conditionType: "SELECT",
    domkey: ['importType'],
    viewAttr: 2,
    label: getLabel(24863,"导入类型"),
    options: [],
}, {
    conditionType: "SELECT",
    domkey: ['importOrder'],
    viewAttr: 2,
    label:getLabel(131321,"Excel数据导入顺序"), 
}, {
    conditionType: "CHECKBOX",
    domkey: ['isNext'],
    viewAttr: 2,
    label: getLabel(129659,"【重复验证字段】的值重复了是否继续"),
}, {
    domkey: ['log'],
    conditionType: 'SWITCH',
    label: getLabel(127410,"打印导入日志"),
    viewAttr: 2,
    value: '1',
    rules: 'required|string',
    className: 'cube-small-item'
}, {
    domkey: ['submit'],
    conditionType: 'INPUT',
    label: getLabel(32935,"导入"),
    viewAttr: 2,
    className: 'cube-small-item'
}].map(f => {
    return {
        ...f,
        labelcol,
        fieldcol
    }
})



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/data/batchImport.ts